import { computed, defineComponent } from 'vue';
import { useDocumentListStore } from '@/store/documents/document-list.store';
import { storeToRefs } from 'pinia';
import TagListCollapsible from '@/components/tag-list-collapsible/tag-list-collapsible';
import { InfoFilled, WarningFilled, WarnTriangleFilled } from '@element-plus/icons-vue';
import { paginationProperties } from '@/constants/common/constants';
import {
  documentActionMap,
  documentColumnLabel,
  documentColumnsList,
} from '@/constants/documents/document-list-column.constant';
import { DocumentAction, DocumentColumnProperties, DocumentListItem } from '@/models/documents/document-list.model';
import { getTextColorByBackground } from '@/utils/get-text-color-by-background.util';
import { useDocumentStore } from '@/store/documents/document.store';
import { useDocumentList } from '@/hooks/documents/document-list.composables';
import { usePermissionsStore } from '@/store/permissions.store';

export default defineComponent({
  name: 'DocumentList',
  components: {
    TagListCollapsible,
    InfoFilled,
    WarnTriangleFilled,
    WarningFilled,
  },
  setup() {
    const { loadDocumentList } = useDocumentList();

    const documentListStore = useDocumentListStore();
    const {
      isDocumentListLoading,
      limit,
      currentPage,
      documentListCount,
      paginatedDocumentList,
    } = storeToRefs(documentListStore);

    const { createDocumentModerationResponse } = useDocumentStore();

    const { documentsPermission } = storeToRefs(usePermissionsStore());

    const isUpdateTransactionModerationInfoFlowAllowed = computed<boolean>(() =>
      documentsPermission.value.isUpdateTransactionModerationInfoFlowAllowed,
    );

    const openPlayerProfile = (playerId: string, whitelabelSlug: string): void => {
      const url = `/player/${playerId}/info?brand=${whitelabelSlug}`;
      window.open(url, '_blank');
    };

    const updateDocumentModeration = async ({
      playerId,
      whitelabelSlug,
      documentModerationAction,
    }: DocumentListItem): Promise<void> => {
      await createDocumentModerationResponse({
        playerId,
        whitelabelSlug,
        documentModerationAction,
      });

      if (documentModerationAction !== DocumentAction.DROP) {
        openPlayerProfile(playerId, whitelabelSlug);
      }

      loadDocumentList();
    };

    return {
      paginatedDocumentList,
      isDocumentListLoading,
      limit,
      currentPage,
      paginationProperties,
      documentListCount,
      documentColumnsList,
      documentColumnLabel,
      DocumentColumnProperties,
      openPlayerProfile,
      getTextColorByBackground,
      documentActionMap,
      updateDocumentModeration,
      isUpdateTransactionModerationInfoFlowAllowed,
    };
  },
});
